import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import 'rxjs/Rx';
import { Observable } from 'rxjs/Rx';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AutorizacionDatosService {

  constructor(
    private http: HttpClient
  ) { }



  getAutorizacionDatos_(idAutorizacion_: string): Observable<boolean> {
    const headers = new HttpHeaders({ 'Authorization': `Bearer ${localStorage.getItem('tokenId')}` });

    return this.http.get(`https://www.mundofinanciera.com:9096/api/fabrica/autorizacionDatosById?idAutorizacion=${idAutorizacion_}`, { headers, observe: 'response' })
      .pipe(
        map((response: HttpResponse<any>) => {
          const confirmado = response.body?.data?.confirmado;
          return !!confirmado; // Devuelve true si confirmado existe y es verdadero, de lo contrario, devuelve false
        })
      );
  }





  aprobarAutorizacionDatos_(idAutorizacion_: string, idTipoDocumento_: string, numeroDocumento_: string
    , primerNombre_: string, segundoNombre_: string
    , primerApellido_: string, segundoApellido_: string
    )
    {
    const body ={
      idAutorizacion: idAutorizacion_.toString(),
      idTipoDocumento : idTipoDocumento_.toString(),
      numeroDocumento : numeroDocumento_.toString(),
      primerNombre : primerNombre_.toString(),
      segundoNombre : segundoNombre_.toString(),
      primerApellido : primerApellido_.toString(),
      segundoApellido : segundoApellido_.toString()
    };

    const headers = new HttpHeaders({ 'Authorization':`Bearer ${localStorage.getItem('tokenId')}`, 'Content-Type':'application/json' });

    return this.http.post(`https://www.mundofinanciera.com:9096/api/fabrica/autorizacionDatosAprobar`, body, { headers, observe: 'response' });
  }



}
